import axios from 'axios'
import jsonpAdapter from 'axios-jsonp'
import filterAlbums from './filterAlbumsToShow'
import transformCloudinaryToMediaServer from './transformCloudinaryToMediaServer'

// For Test DEV BUSINESS ID
const DEV_BUSINESS_ID = ''
// const DEV_BUSINESS_ID = 'bzn-T2vOUVwXQ-SvOoeuX64BGA'
const DEV_API_BASE = 'https://maindiscovery.dev.gonation.com'
const PRODUCTION_API_BASE = 'https://data.gonation.com'
const APIBASE = DEV_BUSINESS_ID ? DEV_API_BASE : PRODUCTION_API_BASE // this is a manaul toggle variable

// Helper function to transform image URLs if needed
const transformImageURL = (imageUrl, mediaServerURL = 'https://res.cloudinary.com/gonation') => {
  if (!imageUrl) return imageUrl

  // If we're using the new media server and the URL contains the old cloudinary URL
  if (mediaServerURL !== 'https://res.cloudinary.com/gonation' && imageUrl.includes('res.cloudinary.com/gonation')) {
    return transformCloudinaryToMediaServer(imageUrl, undefined, mediaServerURL)
  }

  return imageUrl
}

// fetch data from gonation and sets it to component state.
export default async (gonationID, displayAlbums, mediaServerURL = 'https://res.cloudinary.com/gonation') => {
  return await axios({
    url: `${APIBASE}/profile/gallery?profile_id=${gonationID}`,
    adapter: jsonpAdapter
  }).then(res => {
    // checks for albums you want to remove if any else use all albums.
    const albumList = displayAlbums ? filterAlbums(res.data, displayAlbums) : res.data

    // Transform image URLs in the album list if needed
    const transformedAlbumList = albumList.map(album => ({
      ...album,
      photos: album.photos?.map(photo => ({
        ...photo,
        imageUrl: transformImageURL(photo.imageUrl, mediaServerURL)
      }))
    }))

    return transformedAlbumList
    //   setGalleryData({ ...galleryData, albums: albumList, isLoading: false })
  })
}
